import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AppLogo } from '@app/components/app-logo';
import { LayoutService } from '@core/services/layout-store.service';
import { ToggleSidenav } from '@layouts/components/topbar/components/toggle-sidenav';
import { ToggleMobileMenu } from '@layouts/components/topbar/components/toggle-mobile-menu';
import { ProfileDropdown } from '@layouts/components/topbar/components/profile-dropdown/profile-dropdown';
import { ToggleFullscreen } from '@layouts/components/topbar/components/toggle-fullscreen';
import { ThemeToggle } from '@app/components/theme-toggle/theme-toggle';
import { NotificationDropdown } from './components/notification-dropdown';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [
    AppLogo,
    ToggleSidenav,
    ToggleMobileMenu,
    ProfileDropdown,
    ToggleFullscreen,
    ThemeToggle,
    NotificationDropdown,
  ],
  templateUrl: './topbar.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Topbar {
  readonly layoutStore = inject(LayoutService);
}
